import { useContext } from 'react';

import { AdminSessionContext, type AdminSessionContextValue } from './AdminSessionContext';

export function useAdminSession(): AdminSessionContextValue {
  const ctx = useContext(AdminSessionContext);
  if (!ctx) throw new Error('useAdminSession must be used within an AdminSessionProvider.');
  return ctx;
}
